import { AppIdentifier } from '@/interfaces/accounts';
import '@/styles/icons.scss';

export default function Svg() {
  return (
    <svg version="1.1" id="umbrella_icons" x="0px" y="0px" style={{ position: 'absolute', width: 0, height: 0, visibility: 'hidden' }} viewBox="0 0 175 175">
      <linearGradient id="gradient" data-name="Gradient blue-to-green" x1="9.04" y1="87.36" x2="166.33" y2="87.36" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#09f287" />
        <stop offset="0.18" stopColor="#06dfa8" />
        <stop offset="0.38" stopColor="#03cfc2" />
        <stop offset="0.58" stopColor="#01c4d5" />
        <stop offset="0.78" stopColor="#00bde0" />
        <stop offset="1" stopColor="#00bbe4" />
      </linearGradient>

      <defs>
        <defs>
          <symbol id="link_logo" viewBox="0 0 155.91 23.81">
            <title>Link Mobility Logo</title>
            <path
              className="cls-1"
              d="M91.08,60.34A5.31,5.31,0,0,0,89.57,60a8.74,8.74,0,0,0-1.83.07,10.55,10.55,0,0,0-1.86.43,9.61,9.61,0,0,0-1.63.7,6.62,6.62,0,0,0-1.29.91,3.35,3.35,0,0,0-.8,1.07A1.56,1.56,0,0,0,82,64.26a1.6,1.6,0,0,0,.64.87,3.59,3.59,0,0,0,1.38.56,6.77,6.77,0,0,0,1.36.13l.68,0a10.31,10.31,0,0,0,2.29-.44,9.45,9.45,0,0,0,2-.89,5.65,5.65,0,0,0,1.42-1.15,2.34,2.34,0,0,0,.6-1.23,1.38,1.38,0,0,0-.32-1A2.46,2.46,0,0,0,91.08,60.34Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M89.62,69.31a5.77,5.77,0,0,0-1.91-.84,8.09,8.09,0,0,0-2.32-.21A11.59,11.59,0,0,1,81.87,68a5.28,5.28,0,0,1-2.19-1.1,2.53,2.53,0,0,1-.86-1.55,3,3,0,0,1,.39-1.77,1.5,1.5,0,0,0,.21-1,1,1,0,0,0-.44-.66,2.15,2.15,0,0,0-.94-.33,5.09,5.09,0,0,0-1.34,0,8.28,8.28,0,0,0-1.51.36,9.89,9.89,0,0,0-1.45.62,8.71,8.71,0,0,0-1.29.82,5.48,5.48,0,0,0-1,1,2.37,2.37,0,0,0-.48,1,1,1,0,0,0,.14.79,1.4,1.4,0,0,0,.78.52,3.41,3.41,0,0,0,1,.13l.41,0a7.24,7.24,0,0,1,2.52.21,3.9,3.9,0,0,1,1.81,1,3.2,3.2,0,0,1,.84,1.92,5.67,5.67,0,0,1-.55,2.82,4.17,4.17,0,0,0-.38,1.93,3.5,3.5,0,0,0,.61,1.79,4.35,4.35,0,0,0,1.63,1.4,6.74,6.74,0,0,0,2.63.69,9.3,9.3,0,0,0,3.12-.33A9.84,9.84,0,0,0,88.37,77a7.64,7.64,0,0,0,2-1.94,4.87,4.87,0,0,0,.88-2.24,3.53,3.53,0,0,0-.36-2A4,4,0,0,0,89.62,69.31Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M74.15,69.45a2.69,2.69,0,0,0-1.32-.53,5.31,5.31,0,0,0-1.72.06,8.65,8.65,0,0,0-1.95.62,10.92,10.92,0,0,0-1.87,1.07A10.33,10.33,0,0,0,65.76,72a7.7,7.7,0,0,0-1.11,1.48A4.27,4.27,0,0,0,64.11,75a2.19,2.19,0,0,0,.21,1.32,2,2,0,0,0,1,.86,3.73,3.73,0,0,0,1.66.27,6.68,6.68,0,0,0,1.5-.24c.23-.06.48-.14.72-.23a10.5,10.5,0,0,0,2.33-1.21,10.16,10.16,0,0,0,1.89-1.66,6.68,6.68,0,0,0,1.17-1.81,3.14,3.14,0,0,0,.26-1.67A1.84,1.84,0,0,0,74.15,69.45Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M99.95,74.93V61.47H97.52v13.6a3.07,3.07,0,0,0,3.31,3.33h1.5V76.33h-1.07C100.28,76.33,99.95,75.86,99.95,74.93Z"
              transform="translate(-64.09 -60)"
            />
            <rect className="cls-1" x="40.99" y="1.4" width="2.57" height="2.57" />
            <rect className="cls-1" x="41.06" y="6.34" width="2.42" height="12.05" />
            <path
              className="cls-1"
              d="M116.85,66.2a4.31,4.31,0,0,0-3.21,1.36V66.34h-2.38V78.4h2.42V71.05a2.4,2.4,0,0,1,2.5-2.69c1.35,0,2.42.81,2.42,2.69V78.4H121V70.7a4.43,4.43,0,0,0-1.21-3.4A4.18,4.18,0,0,0,116.85,66.2Z"
              transform="translate(-64.09 -60)"
            />
            <polygon
              className="cls-1"
              points="70.74 6.34 67.79 6.34 63.1 11.91 63.1 1.47 60.68 1.47 60.68 18.4 63.1 18.4 63.1 14.86 64.89 12.84 68.26 18.4 71.26 18.4 66.55 11.08 70.74 6.34"
            />
            <path
              className="cls-1"
              d="M155.1,66.28A4.6,4.6,0,0,0,151,68.47a4.06,4.06,0,0,0-3.85-2.19,4.53,4.53,0,0,0-3.55,1.56V66.43h-1.27v12h1.27V71c0-2.26,1.24-3.58,3.38-3.58s3.3,1.27,3.3,3.58V78.4h1.27V70.75A3.15,3.15,0,0,1,155,67.4c2.13,0,3.3,1.27,3.3,3.58V78.4h1.24V70.75a4.5,4.5,0,0,0-1.24-3.33A4.45,4.45,0,0,0,155.1,66.28Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M167.47,66.28a4.59,4.59,0,0,0-3.33,1.32,6.57,6.57,0,0,0-1.49,4.82,6.56,6.56,0,0,0,1.49,4.82,4.86,4.86,0,0,0,6.65,0,6.56,6.56,0,0,0,1.49-4.82,6.56,6.56,0,0,0-1.49-4.82A4.59,4.59,0,0,0,167.47,66.28Zm2.48,10.13a3.54,3.54,0,0,1-5,0c-1-1-1.07-2.61-1.07-4s.07-3,1.07-4a3.54,3.54,0,0,1,5,0c1,1,1.07,2.61,1.07,4S170.94,75.42,169.95,76.41Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M180.4,66.28A4,4,0,0,0,176.85,68V60.72h-1.27V78.4h1.27V76.86a4,4,0,0,0,3.55,1.69,4.18,4.18,0,0,0,2.93-1c1.22-1.22,1.54-3.2,1.54-5.09s-.32-3.87-1.54-5.09A4.18,4.18,0,0,0,180.4,66.28Zm-.17,11.15c-2.93,0-3.38-2.53-3.38-5s.45-5,3.38-5,3.38,2.53,3.38,5S183.16,77.43,180.23,77.43Z"
              transform="translate(-64.09 -60)"
            />
            <rect className="cls-1" x="123.91" y="0.72" width="1.56" height="1.56" />
            <rect className="cls-1" x="124.05" y="6.43" width="1.27" height="11.97" />
            <path
              className="cls-1"
              d="M194.6,75.27V60.72h-1.27V75.3c0,1.86.94,3.1,2.88,3.1h1.09V77.28h-.87C195,77.28,194.6,76.61,194.6,75.27Z"
              transform="translate(-64.09 -60)"
            />
            <rect className="cls-1" x="135.45" y="0.72" width="1.56" height="1.56" />
            <rect className="cls-1" x="135.6" y="6.43" width="1.27" height="11.97" />
            <path
              className="cls-1"
              d="M206.52,62.61h-1.27v3.82h-1.64v.94h1.64v7.89c0,1.81,1,3.13,2.88,3.13h1.09V77.28h-.87c-1.27,0-1.84-.75-1.84-2V67.38h2.71v-.94h-2.71Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M218.61,66.43,215,76.91l-3.6-10.48H210l4.37,12-1,2.66c-.45,1.19-.82,1.64-2.19,1.64h-.47v1.12h.6a3.26,3.26,0,0,0,2.26-.77,3.1,3.1,0,0,0,.82-1.39L220,66.43Z"
              transform="translate(-64.09 -60)"
            />
          </symbol>
        </defs>
        <defs>
          <rect id="lm_rect" x="3.63" y="3.27" width="169.26" height="169.26" rx="12.08" ry="12.08" />
        </defs>

        <g id="lm_blob" className="cls-2">
          <path
            className="cls-3"
            d="M57.53,3.27a6.08,6.08,0,0,0,.24,1.27,9.14,9.14,0,0,0,3.68,4.95,20.47,20.47,0,0,0,7.86,3.18,38.64,38.64,0,0,0,7.75.73q1.86,0,3.87-.16A58.83,58.83,0,0,0,94,10.71a53.94,53.94,0,0,0,11.49-5,39.8,39.8,0,0,0,3.57-2.39H57.53Z"
          />
          <path
            className="cls-3"
            d="M3.64,65.42a54.74,54.74,0,0,0,4.72-4.75A38.13,38.13,0,0,0,15,50.33a17.94,17.94,0,0,0,1.42-9.52,10.48,10.48,0,0,0-3.78-6.68,15.34,15.34,0,0,0-7.52-3Q4.38,31,3.57,30.92v34.5H3.64Z"
          />
          <path
            className="cls-3"
            d="M3.63,18.82V15.35A12.13,12.13,0,0,1,15.71,3.27H40.29a15.37,15.37,0,0,0-.88,7.11,14.44,14.44,0,0,0,4.9,8.86A30.1,30.1,0,0,0,56.82,25.5,66.1,66.1,0,0,0,76.89,27.3,46.19,46.19,0,0,1,90.1,28.48,32.94,32.94,0,0,1,101,33.29a22.75,22.75,0,0,1,7.41,8.26,20.16,20.16,0,0,1,2,11.5,27.76,27.76,0,0,1-5,12.79A43.61,43.61,0,0,1,93.87,76.94a56.11,56.11,0,0,1-16.11,7.32,53.07,53.07,0,0,1-17.86,1.9,38.38,38.38,0,0,1-15-4,24.79,24.79,0,0,1-9.33-8A19.9,19.9,0,0,1,32.07,64a23.8,23.8,0,0,1,2.18-11A32.36,32.36,0,0,0,37.4,36.91,18.27,18.27,0,0,0,32.58,26a22.25,22.25,0,0,0-10.32-6A41.23,41.23,0,0,0,7.88,18.82c-0.81,0-1.61.1-2.35,0.1a17.08,17.08,0,0,1-2-.07h0Z"
          />
        </g>

        <g id="logo_path" data-name="logo">
          <path
            className="logo"
            d="M58.59,151.32c9-32,20.54-66.1,33.79-101.65m0,0S42.7,66.61,10.59,111.08m48.75,40.8A190.89,190.89,0,0,0,9.79,110.37M127.3,150a379.1,379.1,0,0,0-69.36,1.37m68.59-1.42C119.64,99.61,108,74.11,92.38,49.67m0,0C59.27,42.76,31,43.54,11.65,58.5m-1.07,53.27,1-54m80.79-8.06c-7.68-8.71-20.74-26.09-35.2-26M11,59,57.6,23.34m48.46,0q-4.64,1.85-13.68,26.29m-35.74-26,49.93-.29m44.31,34c-6.35-10.59-28.63-18.82-58.5-7.68m53.24,2C130.13,39,124,35.17,105.69,23.12M164.64,107Q140.43,64.41,92.38,49.67M126,150.49l39.2-44.1M150.71,57l14.16,50.89"
            transform="translate(1.9 2.85)"
          />
        </g>

        <symbol id="umbrella_logo_rect_bg" viewBox="0 0 175 175">
          <title>Umbrella logo</title>
          <use href="#lm_rect" fill="#1d153e" />
          <use href="#logo_path" strokeWidth="6px" stroke="url(#gradient)" />
        </symbol>

        <symbol id="umbrella_logo_login" viewBox="0 0 175 175">
          <title>Umbrella logo</title>
          <use href="#logo_path" strokeWidth="6px" stroke="#ffffff" />
        </symbol>

        <symbol id="umbrella_logo_watermark" viewBox="0 0 175 175">
          <title>Umbrella</title>
          <use href="#logo_path" strokeWidth="6px" />
        </symbol>

        <symbol id="umbrella_logo_menu" viewBox="0 0 175 175">
          <title>Umbrella</title>
          <use href="#logo_path" strokeWidth="6px" stroke="url(#gradient)" />
        </symbol>

        <symbol id="rf_icon" viewBox="0 0 175 175">
          <title>Umbrella portal</title>
          <use href="#lm_rect" fill="#0093B9" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(19.04 124.38)">
            Um
          </text>
        </symbol>

        <symbol id="sms_inbox_icon" viewBox="0 0 175 175">
          <title>SMS inbox</title>
          <use href="#lm_rect" fill="#AD1457" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(47.25 124.01)">
            In
          </text>
        </symbol>

        <symbol id="subscription_icon" viewBox="0 0 175 175">
          <title>Subscription</title>
          <use href="#lm_rect" fill="#1565C0" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(34.32 124.85)">
            Su
          </text>
        </symbol>

        <symbol id="permission_icon" viewBox="0 0 175 175">
          <title>Permission</title>
          <use href="#lm_rect" fill="#f9a825" />
          <use href="#lm_blob" />
          <text className="cls-11" transform="translate(36.48 124.32)">
            P
          </text>
          <text className="cls-4" transform="translate(92.21 124.32)">
            e
          </text>
        </symbol>

        <symbol id="push_icon" viewBox="0 0 175 175">
          <title>Push</title>
          <use href="#lm_rect" fill="#00695c" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(33.95 124.11)">
            P
          </text>
          <text className="cls-4" transform="translate(90.67 124.11)">
            u
          </text>
        </symbol>

        <symbol id="sms_tracking_icon" viewBox="0 0 175 175">
          <title>LINKTrack</title>
          <use href="#lm_rect" fill="#00838f" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(42.96 124.54)">
            Tr
          </text>
        </symbol>

        <symbol id="voucher_icon" viewBox="0 0 175 175">
          <title>Voucher</title>
          <use href="#lm_rect" fill="#6a1b9a" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(30.96 124.54)">
            Vo
          </text>
        </symbol>

        <symbol id="webhook_icon" viewBox="0 0 175 175">
          <title>Webhook</title>
          <use href="#lm_rect" fill="#D12C9F" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(17.96 124.54)">
            Wh
          </text>
        </symbol>

        <symbol id="sms_events_icon" viewBox="0 0 175 175">
          <title>SMS Events</title>
          <use href="#lm_rect" fill="#32B27E" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(34.31 125.07)">
            Ev
          </text>
        </symbol>

        <symbol id="bruger_icon" viewBox="0 0 175 175">
          <title>Brugerindsamling</title>
          <use href="#lm_rect" fill="#283593" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(38.31 125.07)">
            Br
          </text>
        </symbol>

        <symbol id="default_icon" viewBox="0 0 175 175">
          <title>Default</title>
          <use href="#lm_rect" fill="#878787" />
          <use href="#lm_blob" />
        </symbol>

        <defs>
          <path
            id="mobile_in_out"
            d="M113.3,50.2V28.8c0-8.9-7.3-16.2-16.2-16.2H40.2c-8.9,0-16.2,7.3-16.2,16.2v118.1c0,8.9,7.3,16.2,16.2,16.2h56.9c8.9,0,16.2-7.3,16.2-16.2V113h-7v23.3H30.8V26.8h75.5v23.3H113.3z M68.7,140.6c5.2,0,9.5,4.2,9.5,9.5s-4.2,9.5-9.5,9.5c-5.2,0-9.5-4.2-9.5-9.5S63.4,140.6,68.7,140.6z"
          />
          <g id="arrow_out">
            <polygon points="60.1,96.3 125.7,96.3 125.7,118.5 161,81.8 125.7,45.2 125.7,67.3 60.1,67.3" />
          </g>
          <g id="arrow_in">
            <polygon points="153.6,70.6 88,70.6 88,48.5 52.7,85.1 88,121.7 88,99.6 153.6,99.6" />
          </g>
          <g id="resend" transform="rotate(-45 75 75)">
            <polygon points="153.6,70.6 88,70.6 88,48.5 52.7,85.1 88,121.7 88,99.6 153.6,99.6" />
          </g>
          <path
            id="refund_arrow"
            stroke="currentColor"
            strokeWidth={18}
            strokeLinejoin="round"
            d="M415.4,157.7c-60-106.2-194.6-143.5-300.8-83.5c0,0-30.5-51.6-31.5-49.1L47.3,139.5l114.5,14.7l-33.9-53.6c42.8-24.6,93.4-31.9,141-19.7c102.2,25.6,164.6,129.3,139.6,231.5c-26,102.2-129.7,165.1-231.5,139.6C77.8,427,15.3,328.2,36,228c2-9.8-27-15.2-29-5.9c-10.8,52.1-2,106.6,24.1,152.8c60,106.2,194.6,143.5,300.8,83.5C438,398.5,475.4,263.9,415.4,157.7z"
          />
          <g id="failed_cross">
            <path d="M133.5,100.5L79.7,46.7c-2.3-2.3-6.2-2.3-8.5,0l-2.8,2.8c-2.3,2.3-2.3,6.2,0,8.5l53.8,53.8 c2.3,2.3,6.2,2.3,8.5,0l2.8-2.8C135.8,106.7,135.8,102.8,133.5,100.5z" />
            <path d="M122.2,46.7l-53.8,53.8c-2.3,2.3-2.3,6.2,0,8.5l2.8,2.8c2.3,2.3,6.2,2.3,8.5,0L133.5,58 c2.3-2.3,2.3-6.2,0-8.5l-2.8-2.8C128.3,44.3,124.5,44.3,122.2,46.7z" />
          </g>
          {/* visibility is reset because the sprite <svg> is visibility:hidden, which masks inherit */}
          <mask id="sms_premium_cutout" maskUnits="userSpaceOnUse" x="0" y="0" width="175" height="175" visibility="visible">
            <rect width="175" height="175" fill="#fff" />
            <path
              transform="translate(26 12.6) translate(77 82) scale(1.2) translate(-77 -82)"
              fill="#000"
              stroke="#000000"
              strokeMiterlimit={10}
              strokeWidth={6}
              d="M81.34,96.62c-7.32,1.23-11.26,2.48-19.59,5.77l-8,3.56-6.51-36.95c6.99-2.71,11.38-4.02,18.84-6.06,13.25-3.06,15.2-3.22,23.68-3.97,3.95-.38,10.2-.16,16.84.46l6.04,36.23c-13.93-.39-23.98-.33-31.3.96Z"
            />
          </mask>
        </defs>

        <symbol id="sms_in" viewBox="0 0 175 175">
          <title>SMS in</title>
          <use href="#mobile_in_out" />
          <use href="#arrow_in" />
        </symbol>

        <symbol id="sms_out" viewBox="0 0 175 175">
          <title>SMS out</title>
          <use href="#mobile_in_out" />
          <use href="#arrow_out" />
        </symbol>

        <symbol id="sms_premium" viewBox="0 0 175 175">
          <title>Premium SMS</title>
          <g mask="url(#sms_premium_cutout)">
            <use href="#mobile_in_out" />
            <path
              transform="translate(26 12.6) translate(77 82) scale(1.2) translate(-77 -82)"
              d="M73.07,86.05c-5.52,3.02-10.39,6.54-14.8,10.84l-4.78,5.3-16.14-33.87c6.01-4.48,9.89-6.91,16.54-10.87,11.96-6.48,12.75-6.83,21.76-10.15,8.39-2.67,9.79-2.87,16.35-4.05l15.49,33.31c-12.02-.26-23.84,3.68-34.42,9.5Z"
            />
          </g>
          <path
            transform="translate(26 12.6) translate(77 82) scale(1.2) translate(-77 -82)"
            d="M81.34,96.62c-7.32,1.23-11.26,2.48-19.59,5.77l-8,3.56-6.51-36.95c6.99-2.71,11.38-4.02,18.84-6.06,13.25-3.06,15.2-3.22,23.68-3.97,3.95-.38,10.2-.16,16.84.46l6.04,36.23c-13.93-.39-23.98-.33-31.3.96Z"
          />
        </symbol>

        <symbol id="vipps_icon" viewBox="43.7 22.2 26 26">
          <title>Vipps</title>
          <path d="M57.3 40.6c3.7 0 5.8-1.8 7.8-4.4 1.1-1.4 2.5-1.7 3.5-.9 1 .8 1.1 2.3 0 3.7-2.9 3.8-6.6 6.1-11.3 6.1-5.1 0-9.6-2.8-12.7-7.7-.9-1.3-.7-2.7.3-3.4 1-.7 2.5-.4 3.4 1 2.2 3.3 5.2 5.6 9 5.6zm6.9-12.3c0 1.8-1.4 3-3 3s-3-1.2-3-3 1.4-3 3-3 3 1.3 3 3z" />
        </symbol>

        <symbol id="resend_icon" viewBox="0 0 175 175">
          <title>Resend</title>
          <use href="#mobile_in_out" />
          <use href="#resend" />
        </symbol>

        <symbol id="sms_failed" viewBox="0 0 175 175">
          <title>SMS failed</title>
          <use href="#mobile_in_out" />
          <use href="#failed_cross" />
        </symbol>

        <symbol id="refund_spinner_icon" viewBox="-22 21 490.5 490.5">
          <title>Refunding</title>
          <use href="#refund_arrow" />
        </symbol>

        <symbol id="refund_icon" viewBox="-12 -12 470.5 536">
          <title>Refund</title>
          <g>
            <use href="#refund_arrow" />
            <polygon points="116.4,201.6 116.4,356.6 149.3,356.6 149.3,301.3 163.2,291.3 203.8,356.6 241.1,356.6 186.6,270.2 240.7,201.6 204.2,201.6 162.2,254.3 149.3,272.6 149.3,201.6" />
            <path d="M299,274.1c5.8-5.3,13.8-8,24.1-8c3.7,0,6.9,0.4,9.5,1.1l2.4-30.3c-2.9-0.6-6.5-1-10.9-1c-7.4,0-14.2,2-20.4,6.1c-6.3,4.1-11.2,9.4-14.9,16.1h-1.6l-4.8-19.9h-24.5v118.5h32.3v-60.3C290.4,286.8,293.3,279.4,299,274.1z" />
          </g>
        </symbol>

        <symbol id="star_icon" viewBox="0 0 576 512">
          <title>Star</title>
          <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
        </symbol>

        <symbol id="call_icon" viewBox="0 0 512 512">
          <title>Call</title>
          <path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z" />
        </symbol>

        <symbol id="read_sms_icon" viewBox="0 0 512 512">
          <title>Read SMS</title>
          <path d="M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z" />
        </symbol>

        <symbol id="megaphone_icon" viewBox="0 0 576 512">
          <title>Megaphone</title>
          <path d="M32 176c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32 11.38 0 20.9-6.28 26.57-15.22l106.99 32.3c-3.35 9.76-5.56 20.04-5.56 30.92 0 52.94 43.06 96 96 96 44.49 0 81.66-30.57 92.5-71.7L480 448V64L58.57 191.22C52.9 182.28 43.38 176 32 176zm179.29 190.88l91.47 27.61C297.95 415.92 278.85 432 256 432c-26.47 0-48-21.53-48-48 0-6.05 1.24-11.79 3.29-17.12zM560 32h-32c-8.84 0-16 7.16-16 16v416c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16z" />
        </symbol>

        <symbol id="comment_icon" viewBox="0 0 512 512">
          <title>Comment</title>
          <path d="M256 296c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-8.5-24h17c4.2 0 7.7-3.3 8-7.5l7-112c.3-4.6-3.4-8.5-8-8.5h-31c-4.6 0-8.3 3.9-8 8.5l7 112c.3 4.2 3.8 7.5 8 7.5zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z" />
        </symbol>

        <symbol id="file_download_icon" viewBox="0 0 64 64">
          <title>Download file</title>
          <path d="M44.4 40.3c-.2-.5-.8-.9-1.4-.9h-5.7V28.8H26.7v10.7H21c-.6 0-1.1.3-1.4.9-.2.5-.1 1.2.3 1.6l11 10.7c.3.3.6.4 1 .4s.8-.1 1-.4l11-10.7c.6-.5.7-1.2.5-1.7zm-8.6 2h3.6L32 49.5l-7.4-7.2h3.6c.8 0 1.5-.6 1.5-1.4v-9.2h4.7v9.2c0 .7.6 1.4 1.4 1.4z" />
          <path d="M55.5 15.9L40.9.9c-.3-.3-.6-.4-1-.4H11.4C9.6.5 8 2.1 8 3.9V60c0 .9.4 1.8 1.1 2.5.6.6 1.6 1 2.5 1h40.9c.9 0 1.8-.4 2.4-1 .7-.7 1-1.5 1-2.4V17c0-.4-.1-.7-.4-1.1zM40.1 4.3L51.5 16H40c.1-6 .1-9.6.1-11.7zm-2.5 14.2c.3.3.6.4 1 .4h14.5v41.2c0 .1-.1.2-.2.3-.1.1-.2.1-.4.1H11.6c-.2 0-.4-.1-.5-.2-.2-.2-.3-.3-.3-.4v-56c0-.2.3-.5.6-.5h25.8v14c0 .4.1.8.4 1.1z" />
        </symbol>
      </defs>
    </svg>
  );
}

export const iconMap: Record<AppIdentifier, IconName> = {
  PORTAL: '#umbrella_logo_menu',
  SMSINBOX: '#sms_inbox_icon',
  PUSH: '#push_icon',
  PERMISSION: '#permission_icon',
  SUBSCRIPTION: '#subscription_icon',
  WEBHOOK: '#webhook_icon',
  LINKTRACK: '#sms_tracking_icon',
  VOUCHER: '#voucher_icon',
  SMSEVENTS: '#sms_events_icon',
};

export type IconName =
  | '#link_logo'
  | '#umbrella_logo_menu'
  | '#umbrella_logo_rect_bg'
  | '#sms_inbox_icon'
  | '#subscription_icon'
  | '#permission_icon'
  | '#push_icon'
  | '#sms_tracking_icon'
  | '#voucher_icon'
  | '#webhook_icon'
  | '#sms_events_icon'
  | '#bruger_icon'
  | '#default_icon'
  | '#rf_icon'
  | '#umbrella_logo_login'
  | '#umbrella_logo_watermark'
  | '#sms_in'
  | '#sms_out'
  | '#sms_premium'
  | '#vipps_icon'
  | '#resend_icon'
  | '#sms_failed'
  | '#refund_icon'
  | '#refund_spinner_icon'
  | '#star_icon'
  | '#call_icon'
  | '#read_sms_icon'
  | '#megaphone_icon'
  | '#comment_icon'
  | '#file_download_icon';

export function Icon({
  name,
  size = 24,
  width,
  height,
  title,
  viewBox,
  className,
}: {
  name: IconName;
  size?: number;
  width?: number;
  height?: number;
  title?: string;
  viewBox?: string;
  className?: string;
}) {
  return (
    <svg
      className={className}
      width={width ?? size}
      height={height ?? size}
      viewBox={viewBox ?? '0 0 175 175'}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <use href={`${name}`} />
    </svg>
  );
}
